import React from "react";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import PDFPage from "pdfs/PDFPage";
import MonthlyPpcSection from "./MonthlyPpcSection";

function MonthlyPpcReport(props) {
  const page = props.page;
  const dashboard = props.dashboard;
  if (page) {
    if (page["metricNames"]) {
      let sectionNames = page["metricNames"]
        .map((metric) => metric)
        .filter((value, index, self) => self.findIndex((el) => el.section == value.section && el.service == value.service) === index);
      let sections = [];
      // Create sections object and format how the dashboard generation loop expects
      sectionNames.forEach((section, index) => {
        sections.push({
          name: section.section,
          service: section.service,
          metrics_data: page["metricNames"]
            .filter((m) => m["section"] == section.section && m["service"] == section.service)
            .reduce((sum, item) => {
              sum[item["name"]] = "1";
              return sum;
            }, {}),
        });
      });

      return (
        <PDFPage pageNumber={props.pageNumber} hideLogo={props.white_label_service}>
          {sections.map((section, index) => {
            return (
              <div key={index}>
                <MonthlyPpcSection client={props.client_name} section={section} sections={sections} sectionIndex={index} dashboard={dashboard} {...props} />
              </div>
            );
          })}
        </PDFPage>
      );
    } else {
      return (
        <>
          <h4 className="text-danger">no metricsData in page</h4>
        </>
      );
    }
  } else {
    return (
      <></>
    )
  }
}
export default MonthlyPpcReport;
